export const FEATURE_FLAGS = {
  REVIEWS: true,
  REPORT: true,
} as const;
